import React from 'react';

export default function Header() {
    return (
        <header className="onBoard-1 onBoard-6 container py-8 px-2 sm:px-8 max-w-2xl mx-auto">
                <h1 className="border-l-4 border-brand pl-4 text-4xl font-semibold text-brand dark:text-white">
                    COVID-19 REPORT
                </h1>
                <p className="border-l-4 border-brand pl-4 text-md text-gray-400">
                    Here&#x27;s what&#x27;s happening with COVID-19 Situation today.
                </p>
        </header>
    )
}